export const SLACK_ID_WHITELIST = [
  'U06GDCST7G9',
  'U02RDDB4XBP',
  'U031P5WP9SA',
  'U02RV0WL8C9',
  'U0357MP1XT5',
  'U035ZB1UJ3F',
  'U039N2W365D',
  'U07KZ2GRZPX',
  'U07MGMALL58',
];

export const MIN_DURATION_SECS = 30;
export const SILENCE_DURATION_MS = 1200;
export const ELEVEN_LABS_AGENT_ID = 'Q0egWSXZnQt9JQRu9FQd';
export const ELEVEN_LABS_OCTAVE_AGENT_ID = 'dmbkJs9j2ZDbCakDqPL5';
export const DAVY_FAQ_AGENT_ID = 'agent_0901kpqgdy51f9nt01ng9t5a60s7';
export const AIAKO_FAQ_AGENT_ID = 'agent_9001kr08qbyhffcbks7yvgmf6v1a';
export const ELEVEN_LABS_JAMES_VOICE_ID = 'aSXZu6bgEOS8MXVRzjPi'; // James voice for ElevenLabs
export const INSURANCE_SALES_AGENT_ID = 'rn99m7ZozcY1z8QD01zj';
export const CUSTOMER_AGENT_ID = 'DpmpBWs2xUuY9KKPjrl0';
export const COLD_CALL_VOICE_ID = 'aSXZu6bgEOS8MXVRzjPi'; // James voice for cold calling

export const DEFAULT_PERSONA = 'sensible';

export const PERSONA_OPTIONS = [
  {
    id: 'sensible',
    title: 'Sensible',
    description:
      'A mix of confidence and self-doubt, stays open yet selective with feedback.',
    emoji: '🤝',
  },
  {
    id: 'passive',
    title: 'Passive',
    description:
      'Rarely speaks up, gives minimal responses, and needs active prompting to engage.',
    emoji: '🤫',
  },
  {
    id: 'anxious',
    title: 'Anxious',
    description:
      'Overthinks decisions, seeks reassurance, and struggles with criticism.',
    emoji: '😰',
  },
  {
    id: 'defensive',
    title: 'Defensive',
    description:
      'Confident and data-driven, challenges feedback and demands strong evidence before accepting change.',
    emoji: '🛡️',
  },
];

export const noop = () => void 0;

export enum SessionPhase {
  PRE_START = 'pre_start',
  CONNECTING = 'connecting',
  INTRO = 'intro',
  MAIN_CONVERSATION = 'main_conversation',
  ENDING = 'ending',
  DONE = 'done',
}

// Language to voiceId mapping
export const LANGUAGE_TO_VOICE_ID: Record<string, string> = {
  id: 'I8CjX5UAVryGmxXzlF6m',
  zh: 'VGcvPRjFP4qKhICQHO7d',
};

// supported languages list
export const SUPPORTED_LANGUAGES = [
  {
    code: 'en',
    name: 'English',
    flag: '🇺🇸',
    TTS: 'en-US',
    firstMessage: 'Hello',
    voiceId: 'tpFVjZdYBvOaWaUIRHRz',
  },
  {
    code: 'ko',
    name: '한국어',
    flag: '🇰🇷',
    TTS: 'ko-KR',
    firstMessage: '안녕하세요',
    voiceId: 'uyVNoMrnUku1dZyVEXwD',
  },
  {
    code: 'ja',
    name: '日本語',
    flag: '🇯🇵',
    TTS: 'ja-JP',
    firstMessage: 'こんにちは',
    voiceId: '8EkOjt4xTPGMclNlh1pk',
  },
  {
    code: 'fr',
    name: 'Français',
    flag: '🇫🇷',
    TTS: 'fr-FR',
    firstMessage: 'Bonjour',
    voiceId: 'F1toM6PcP54s45kOOAyV',
  },
  {
    code: 'zh',
    name: '中文',
    flag: '🇨🇳',
    TTS: 'cmn-TW',
    firstMessage: '你好',
    voiceId: 'ByhETIclHirOlWnWKhHc',
  },
  {
    code: 'zh-tw',
    name: '繁體中文',
    flag: '🇹🇼',
    TTS: 'cmn-TW',
    firstMessage: '你好',
    voiceId: 'ByhETIclHirOlWnWKhHc',
  },
  {
    code: 'yue',
    name: '廣東話',
    flag: '🇭🇰',
    TTS: 'yue-CN',
    firstMessage: '你好',
    voiceId: '0IVMOjoIFwzWOIVVPEmU',
  },
  {
    code: 'cmn',
    name: '普通话',
    flag: '🇨🇳',
    TTS: 'cmn-CN',
    firstMessage: '你好',
    voiceId: 'VGcvPRjFP4qKhICQHO7d',
  },
  {
    code: 'th',
    name: 'ไทย',
    flag: '🇹🇭',
    TTS: 'th-TH',
    firstMessage: 'สวัสดี',
    voiceId: 'VGcvPRjFP4qKhICQHO7d',
  },
  {
    code: 'id',
    name: 'Bahasa Indonesia',
    flag: '🇮🇩',
    TTS: 'id-ID',
    firstMessage: 'Halo',
    voiceId: 'd888tBvGmQT2u05J1xTv',
  },
  {
    code: 'tl',
    name: 'Tagalog',
    flag: '🇵🇭',
    TTS: 'fil-PH',
    firstMessage: 'Kumusta',
    voiceId: 'VGcvPRjFP4qKhICQHO7d',
  },
  {
    code: 'vi',
    name: 'Tiếng Việt',
    flag: '🇻🇳',
    TTS: 'vi-VN',
    firstMessage: 'Xin chào',
    voiceId: 'VGcvPRjFP4qKhICQHO7d',
  },
  {
    code: 'ms',
    name: 'Bahasa Melayu',
    flag: '🇲🇾',
    TTS: 'ms-MY',
    firstMessage: 'Helo',
    voiceId: 'VGcvPRjFP4qKhICQHO7d',
  },
  {
    code: 'ar',
    name: 'العربية',
    flag: '🇸🇦',
    TTS: 'ar-SA',
    firstMessage: 'مرحباً',
    voiceId: 'RjFuvnufLX42TYe37ekK', // Arabic voice for Tawuniya
  },
  {
    code: 'sw',
    name: 'Kiswahili',
    flag: '🇰🇪',
    TTS: 'sw-KE',
    firstMessage: 'Habari',
    voiceId: '0IVMOjoIFwzWOIVVPEmU',
  },
];

// HeyGen avatar constants
export const HEYGEN_AVATARS = {
  DEFAULT: 'June_HR_public',
  JUNE: 'June_HR_public',
  ALEX: 'alex_realistic',
  WAYNE: 'Wayne_20240711',
};

// App module constants
export const APP_MODULES = [
  {
    id: 'staying-centered',
    title: 'Staying Centered When Things Get Tense',
    description:
      'Learn techniques to remain calm and balanced during challenging situations',
    icon: '🧘',
  },
  {
    id: 'breaking-free',
    title: 'Breaking Free from Limiting Beliefs',
    description:
      'Identify and overcome self-imposed limitations and negative thought patterns',
    icon: '🚀',
  },
  {
    id: 'expressing-emotions',
    title: 'Understanding and Expressing Emotions Constructively',
    description:
      'Develop healthy ways to process and communicate your feelings',
    icon: '💭',
  },
  {
    id: 'general-coaching',
    title: 'General Coaching Session',
    description:
      'Open-ended coaching on any personal or professional challenge',
    icon: '🧠',
  },
];

// Default API endpoints
export const API_ENDPOINTS = {
  APP_MODULE_INSTRUCTIONS: (moduleId: string) =>
    `/api/app/modules/${moduleId}/instructions`,
};
